import React, {useCallback, useEffect, useState} from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    Menu,
    MenuItem,
    TextField,
    Theme,
    Typography,
    useMediaQuery
} from "@mui/material";
import {agregarEditarAgente, eliminarAgente, toggleLock} from "../../redux/reducers/agentesReducers";
import Strings from "../../assets/strings"
import {SelectCaja, SelectRol, SelectRutas} from "../../components/selects";
import TopBarDialog from "../../components/topBar/TopBarDialog";
import {SlideTransition} from "../../components/transitions";
import {useLocation, useNavigate} from "react-router-dom";
import {nullToEmptyString} from "../../helpers";
import {ConfirmDialog, LoadingProgress, MostrarError} from "../../components";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {editPWAgente} from "../../services";
import {isMobile} from "../../helpers/browser_detect";
import {IUserAgente} from "../../redux/types/IUser";
import TextFieldPhone from '../../components/TextFieldPhone';

const TranLeft = SlideTransition("left");

const initialState:IUserAgente ={

    id: undefined,
    inicioSesion: "",
    clave: "",

    nombre: "",
    email: "",
    telefono: "",
    rutas: "",
    rolId: undefined,
    cajaIdDefault: undefined,



};
export default function CrearAgente() {
    const navigate = useNavigate();
    const location = useLocation();
    const {status, error} = useAppSelector(state => state.agentes);
    const Dispatch = useAppDispatch();

    const {state:urlState} = useLocation();

    const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
    const [showMenu, setShowMenu] = useState<null | HTMLElement>(null);
    const [showFormPass, setShowFormPass] = useState(false);
    const [errorPass, setErrorPass] = useState("");
    const [clave2Confirmar, setClave2Confirmar] = useState("");

    const [state, setState] = useState(initialState);
    const resetBack = useCallback(
        () => {
            setErrorPass("");
            setShowFormPass(false);
            navigate(-1);
        },
        [setShowFormPass,navigate],
    );
    useEffect(() => {
        if(urlState?.usuario)
            setState(state=>({...state,...nullToEmptyString(urlState.usuario)}));
        else
            setState(initialState);

    }, [setState, urlState,resetBack]);

    const eliminar  = () =>{
        Dispatch(eliminarAgente(urlState?.confirmDialog))
    };
    const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setState({...state,[name]:value})
    };
    const handleSubmit = (e:React.FormEvent<HTMLFormElement>)  => {
        e.preventDefault();
        setErrorPass("");
        let clave = "";
        if(showFormPass || !state.id){
            clave = state.clave??"";
            if(clave !== clave2Confirmar){
                return setErrorPass(Strings.contrasenaNoMatchMjs)
            }
        }
        if(showFormPass)
            editPWAgente({id:state.id!, clave:clave}).then(res=>{
                setShowFormPass(false);
                setErrorPass("Se edito la contraseña")
                setState(state=>({...state,...nullToEmptyString(urlState)}));
            })
        else
            Dispatch(agregarEditarAgente({...state,clave,}));

    };
    const url = `https://prestamistapp.com/solicitarCredito/${state.inicioSesion}`;//`https://prestamistapp.com/solicitar/${state.inicioSesion}`;

    return (
        <>
            <Dialog open={urlState?.hasOwnProperty("usuario")} onClose={resetBack}
                    {...(smVewport ? {TransitionComponent: TranLeft}:{})}
                    fullScreen={smVewport}>

                <TopBarDialog title={Strings.usuario} onClose={resetBack}>
                    {!showFormPass && !!state.id &&
                        <>
                    <Button size={"small"} onClick={(e)=>setShowMenu(e.currentTarget)} color="inherit" sx={{mr:"4px"}}>
                        Opciones
                    </Button>
                    <Menu
                        id="menu-appbar"
                        anchorEl={showMenu}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(showMenu)}
                        onClose={()=>setShowMenu(null)}
                    >
                        <MenuItem onClick={()=>{setShowMenu(null);Dispatch(toggleLock(state.id!))}}>{!state.inactivo ? Strings.bloquear:Strings.desbloquear} {Strings.usuario}</MenuItem>
                        <MenuItem onClick={()=>{setShowMenu(null);setShowFormPass(true)}}>{"Restablecer "+ Strings.contrasena}</MenuItem>
                        <MenuItem onClick={()=>{
                            setShowMenu(null);
                            navigate(location.pathname, {state:{...state,confirmDialog:state.id}})
                        }}>{Strings.eliminar} {Strings.usuario}</MenuItem>
                        <MenuItem
                            onClick={()=>{
                                if((window as any).ReactNativeWebView) {
                                    let ms = {
                                        action: "shareLink",
                                        payload:  {
                                            caption:"Formulario de solicitud.",
                                            url: url
                                        }
                                    }
                                    return (window as any).ReactNativeWebView.postMessage(JSON.stringify(ms))

                                }else if(isMobile.AndroidWebView())
                                    (window as any).Android.shareLink(url);
                                else if(isMobile.IosWebView())
                                    (window as any).webkit.messageHandlers.shareLink.postMessage(url)
                                else
                                    (window as any).open(url,'_blank');
                            }}
                        >
                            {Strings.enlace} {Strings.solicitud}
                        </MenuItem>
                    </Menu></>}
                </TopBarDialog>
                {!!state.id &&
                    <Box padding={"5px 16px"} bgcolor={"#ececec"}>
                        <Typography color={!!state.inactivo ? "error":"primary"} variant={"body2"}>{Strings.estado}: {!!state.inactivo ? Strings.inactivo:Strings.activo}</Typography>
                    </Box>
                }

                    <DialogContent>
                        <MostrarError errors={errorPass?errorPass:error}/>
                        {status === "loading" && <LoadingProgress/>}
                        <br/>
                        <form id="form1" onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                {!showFormPass && <>
                                <Grid item xs={6}>
                                    <TextField
                                        name="inicioSesion"
                                        value={state.inicioSesion}
                                        onChange={handleChange}
                                        inputProps={{maxLength: 50}}
                                        label={Strings.nombreDeUsuario}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        name="nombre"
                                        value={state.nombre}
                                        onChange={handleChange}
                                        inputProps={{maxLength: 50}}
                                        label={Strings.primerNombre}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        name="email"
                                        type="email"
                                        value={state.email}
                                        onChange={handleChange}
                                        inputProps={{maxLength: 50}}
                                        label={Strings.email}
                                        fullWidth
                                    />
                                </Grid>
                                    <Grid item xs={6}>
                                        <TextFieldPhone
                                            name="telefono"
                                            value={state.telefono}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 20}}
                                            required
                                            label={Strings.telefono}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <SelectCaja
                                            name="cajaIdDefault"
                                            value={state.cajaIdDefault}
                                            onChange={handleChange}
                                            //  allowNone={false}
                                            allowAll
                                            label={Strings.caja}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <SelectRol
                                            name="rolId"
                                            value={state.rolId}
                                            required
                                            onChange={handleChange}
                                            label={Strings.rol}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectRutas
                                            name="rutas"
                                            value={state.rutas}
                                            onChange={handleChange}
                                        />
                                    </Grid></>}
                                {(showFormPass || !state.id) &&
                                    <>
                                    <Grid item xs={6}>
                                        <TextField
                                            name="clave"
                                            value={state.clave}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            required
                                            label={Strings.contrasena}
                                            type="password"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            name="clave2"
                                            value={clave2Confirmar}
                                            onChange={({target})=>setClave2Confirmar(target.value)}
                                            required
                                            label={Strings.confirmar+" "+Strings.contrasena}
                                            type="password"
                                            fullWidth
                                        />
                                    </Grid>
                                    </>
                                }
                            </Grid>
                        </form>
                        <br/>
                    </DialogContent>
                    <DialogActions>
                    {/* {!showFormPass && <>
                        <Button onClick={()=>setShowFormPass(false)} color="primary">{Strings.eliminar}</Button>
                        <Button onClick={()=>setShowFormPass(false)} color="primary">{!state.inactivo ? Strings.bloquear:Strings.desbloquear}</Button>
                    </>}
 */}

                        <Button type={"button"} color="warning" variant={"text"} onClick={()=>{
                            if(showFormPass){
                                setShowFormPass(false)
                            }else{
                                resetBack()
                            }
                        }}>
                            {Strings.cancelar}
                        </Button>


                        <Button type={"submit"} form={"form1"}  color="primary" disabled={status === "loading"} variant={"outlined"}>
                            {!!state.id ? Strings.actualizar : Strings.guardar}
                        </Button>
                    </DialogActions>

            </Dialog>
            {!!urlState?.hasOwnProperty("confirmDialog") &&
                <ConfirmDialog replace={"/agentes"} onConfirm={eliminar}/>
            }
        </>
    );

}
